import { useState } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { validateEmail } from '../../global/helpers/global-helpers';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckFormInput from '../../forms/TextInputField/components/LaunchdeckFormInput';

export default function DsrDetermineUidForm({ handleRetrieveUid }) {

	const [userEmailInput, setUserEmailInput] = useState('');
	const [showInputError, setShowInputError] = useState(false);


	//Function
	const handleButtonClick = () => {
		if (validateEmail(userEmailInput)) {
			handleRetrieveUid(userEmailInput)
		} else {
			setShowInputError(true)
		}
	}

	const onChangeHandler = (event) => {
		setShowInputError(false)

		switch (event.target.name) {
			case ('email'): {
				setShowInputError(false)
				setUserEmailInput(event.target.value.trim())
				break;
			}
			default: {
				break;
			}
		}
	};

	const onPressEnter = (e) => {
		if (e.key === 'Enter') {
			handleButtonClick();
		}
	}


	return (
		<Box w="100%" align="center" maxW='25em'>
			<Box mt='1em' w='100%' onKeyDown={(e) => onPressEnter(e)}>
				<LaunchdeckFormInput
							label='Email'
							name={'email'}
							onChange={onChangeHandler}
							value={userEmailInput}

							errorLogic={showInputError}
							errorMessage={`Please provide a valid email`}
							autoFocus={true}
						/>
			</Box>

			<Flex w='100%' mt='2em' py='0.625em'>
				<Flex justify='center' w='100%'>
					<LaunchdeckButton bg='brand.500' color='gray.50' w='100%' label='Proceed' onClick={() => handleButtonClick()} />
				</Flex>
			</Flex>
		</Box>
	);
};

